<template>
  <div class="carousel-container">
    <div class="carousel-slides" :style="{ transform: `translateX(-${currentIndex * 100}%)` }">
      <div class="carousel-slide" v-for="(img, idx) in images" :key="idx">
        <div class="slide-content">
          <img :src="img" :alt="getSlideTitle(idx)" class="slide-image">
          <div class="slide-text" :class="{ 'text-left': idx % 2 === 0, 'text-right': idx % 2 === 1 }">
            <h3 class="slide-title">{{ getSlideTitle(idx) }}</h3>
            <p class="slide-description">{{ getSlideDescription(idx) }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="carousel-dots">
      <span v-for="(_, idx) in images" :key="idx"
            class="dot" :class="{ active: currentIndex === idx }"
            @click="goToSlide(idx)"></span>
    </div>
  </div>
</template>

<script>
export default {
  props: ['images'],
  data() {
    return { currentIndex: 0, timer: null };
  },
  mounted() { this.startTimer(); },
  beforeDestroy() { if (this.timer) clearInterval(this.timer); },
  methods: {
    nextSlide() { this.currentIndex = (this.currentIndex + 1) % this.images.length; },
    goToSlide(index) { this.currentIndex = index; this.resetTimer(); },
    startTimer() { this.timer = setInterval(this.nextSlide, 4000); },
    resetTimer() { clearInterval(this.timer); this.startTimer(); },
    getSlideTitle(index) {
      const titles = [
      '手术室行为管理系统',  
      '手术室麻醉药品管理系统',
      '智慧手术室物资管理系统',
        
        
        '手术室耗材管理系统',
        '智慧治疗室'
      ];
      return titles[index] || '智慧手术室解决方案';
    },
    getSlideDescription(index) {
      const descriptions = [
        '精准管理手术室人员行为，提升工作效率和安全性,运用自动化的手段、信息化的管理是手术室物资管理发展的要求与必然趋势',
        '用于满足国家对于麻醉药品的五专管理要求，实现手术间对麻醉药品、精神类药品的自动化发放及全程可溯',
        '应用AI+IOT、运动矢量、标记物几何形状的示 例多维度识别算法、RFID技术，对耗材、器械包、器械实现自动化发放、密集存储、自动运输、实时盘点、信息化追溯',
        '精细化管控手术室耗材，降低运营成本提高效率',
        '治疗室智能柜应用在病区治疗室等相关地方，通过智能化的方式对各种药品、耗材进行进管控'
      ];
      return descriptions[index] || '专业的医疗科技解决方案';
    }
  }
};
</script>

<style scoped>
.carousel-container {
  position: relative;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
  background: linear-gradient(135deg, #0a0a0f 0%, #1a1a2e 50%, #16213e 100%);
  border-radius: 0;
}

.carousel-slides {
  display: flex;
  transition: transform 0.5s ease;
}

.carousel-slide {
  flex-shrink: 0;
  width: 100%;
  position: relative;
}

.slide-content {
  position: relative;
  height: 500px;
  display: flex;
}

.slide-image {
  width: 65%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.slide-text {
  width: 35%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 2rem 4rem;
  background: linear-gradient(135deg, #1e3a5f 0%, #0d1b2a 50%, #1b263b 100%);
}

.text-left {
  order: 1;
}

.text-right {
  order: 2;
}

.slide-title {
  font-size: 2.2rem;
  font-weight: 700;
  color: #00ffff;
  margin-bottom: 1rem;
  line-height: 1.2;
  text-shadow: 0 0 20px rgba(0, 255, 255, 0.5);
}

.slide-description {
  font-size: 1.1rem;
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.6;
  margin: 0;
}

.carousel-dots {
  position: absolute;
  bottom: 30px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  gap: 12px;
}

.dot {
  width: 10px;
  height: 10px;
  background: rgba(0, 255, 255, 0.4);
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.3s ease;
}

.dot.active {
  background: #00ffff;
  width: 24px;
  border-radius: 10px;
  box-shadow: 0 0 15px rgba(0, 255, 255, 0.6);
}

.dot:hover {
  background: #00ffff;
  transform: scale(1.2);
}

@media (max-width: 768px) {
  .slide-content {
    height: 350px;
    flex-direction: column;
  }
  
  .slide-image {
    width: 100%;
    height: 60%;
  }
  
  .slide-text {
    position: relative;
    width: 100%;
    height: 40%;
    text-align: center;
  }
  
  .slide-title {
    font-size: 1.6rem;
  }
  
  .slide-description {
    font-size: 1rem;
  }
}
</style>